import moment from "moment";

/**
 * Calcule l'état de maintenance d'un moteur.
 * Remplace la logique répétée 3x dans maintenanceMap.
 */
export function getMaintenanceState(motor, motorsList) {
  const getStateFromMaintenances = (maintenances) => {
    const states = maintenances.map((m) => m.etatIntervention?.toLowerCase());
    if (states.includes("a faire")) return "A faire";
    if (states.includes("a prévoir")) return "A prévoir";
    return "A jour";
  };

  if (motor.id_moteurs_replace?.length > 0) {
    const lastId = motor.id_moteurs_replace[motor.id_moteurs_replace.length - 1];
    const lastMotor = motorsList.find((m) => m._id === lastId);
    if (lastMotor) return getStateFromMaintenances(lastMotor.maintenances);
  }

  return getStateFromMaintenances(motor.maintenances);
}

/**
 * Calcule la priorité vibratoire d'un moteur (0 = le plus critique).
 */
export function getPrioriteVibratoire(info) {
  const isRouge = info.messagePrincipal.includes("IMPORTANT");
  const isJaune = info.messagePrincipal.includes("À SURVEILLER");
  const isNormal = info.messagePrincipal.includes("NORMAL");
  const hasSecondaire = !!info.messageSecondaire;

  if (isRouge) return 0;
  if (isJaune) return hasSecondaire ? 1 : 2;
  if (isNormal) return hasSecondaire ? 3 : 4;
  return 5;
}

/**
 * Formate la durée depuis la dernière trame reçue.
 */
export function formatDureeDepuis(lastTrameDate) {
  const diff = moment.duration(moment().diff(moment(lastTrameDate)));
  return `${Math.floor(diff.asDays())} jours, ${diff.hours()} heures et ${diff.minutes()} minutes`;
}

/**
 * Calcule la consommation affichée selon le nom du moteur.
 * Logique métier centralisée ici plutôt qu'inline dans le JSX.
 */
export function getConsommationAffichee(motor, consoMap) {
  if (isNaN(motor.consommation)) return "";
  if (motor.nom_moteur === "Turbine 1") return Math.round(motor.consommation / 3.565);
  if (motor.nom_moteur === "Compresseur") return Math.round(motor.consommation / 115.5);
  return Math.round(consoMap[motor._id]?.toFixed(0));
}